<template>
  <page-template type="norightpanel" class="gestion-points-catalogue">
    <template v-slot:toolbar>
        <tool-bar @status-change="$router.push(`/gestion-points${$event}`)" default-gestion-points="/catalogue" type="gestion-points" title="Gestion des points" class="px-8"></tool-bar>
    </template>
    <template v-slot:main-panel-content>
      <div class="padding-x">
        <div class="d-flex rectangular-element-container">
          <rectangular-element-new title="Nouveau lot" link="/gestion-points/catalogue/new"></rectangular-element-new>
          <rectangular-element
            v-for="prize in cachedPrizes"
            :key="prize._id"
            :title="prize.title"
            :count="prize.count"
            :actions="items"
            :id="prize._id"
            :publish-url="`${apiURL}/manage/prize/status/activate/${prize._id}`"
            :publish-object="prize"
            @update="updatePrizes()"
            :class="prize.activated ? 'on-going' : 'to-publish'"
          ></rectangular-element>
        </div>
      </div>
    </template>
  </page-template>
</template>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import rectangularElement from '@/components/RectangularElement.vue'
  import rectangularElementNew from '@/components/RectangularElementNew.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'GestionPointsCatalogue',
    components: { pageTemplate, toolBar, rectangularElement, rectangularElementNew },
    data: () => {
      return {
        prizes: [],
        apiURL
      }
    },
    async created () {
      try {
        // ALL PRIZES
        const prizesRes = await axios.get(`${apiURL}/data/prizes`)
        this.prizes = prizesRes.data.model
        // PRIZE CATEGORIES
        const prizeCategoriesRes = await axios.get(`${apiURL}/data/prize/v/categories`)
        this.prizeCategory = prizeCategoriesRes.data.model
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      }
    },
    computed: {
      cachedPrizes () {
        if (!this.prizes.length) return []
        return this.prizes
      },
      items () {
        return [
          { title: 'Editer', icon: 'mdi-square-edit-outline', callback: this.editCb },
          { title: 'Ouvrir', icon: 'mdi-eye-outline', callback: this.openCb },
          { title: 'Dupliquer', icon: 'mdi-checkbox-multiple-blank-outline', callback: this.duplicateCb },
          { title: 'Désactiver', icon: 'mdi-close', callback: this.deactivateCb },
          { title: 'Supprimer', icon: 'mdi-trash-can-outline', callback: this.deleteCb }
        ]
      }
    },
    methods: {
      async updatePrizes () {
        try {
          this.$store.dispatch('loading')
          // ALL PRIZES
          const prizeRes = await axios.get(`${apiURL}/data/prizes`)
          this.prizes = prizeRes.data.model
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      },
      // EDIT PRIZE
      editCb (id) {
        this.$router.push(`/gestion-points/catalogue/edit/${id}`)
      },
      // OPEN PRIZE
      openCb (id) {
        this.$router.push(`/gestion-points/catalogue/open/${id}`)
      },
      // DUPLICATE PRIZE
      async duplicateCb (id) {
        try {
          this.$store.dispatch('loading')
          await axios.post(`${apiURL}/manage/prize/duplicate/${id}`)
          await this.updatePrizes()
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      },
      // DEACTIVATE PRIZE
      async deactivateCb (id) {
        try {
          this.$store.dispatch('loading')
          await axios.put(`${apiURL}/manage/prize/status/deactivate/${id}`)
          await this.updatePrizes()
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      },
      // DELETE PRIZE
      async deleteCb (id) {
        try {
          this.$store.dispatch('loading')
          await axios.delete(`${apiURL}/manage/prize/${id}`)
          await this.updatePrizes()
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      }
    }
  }
</script>